import component from "./PageHeader";
export default component;
